import { getRoadMapsById, getRoadmapsTypeStatusesByRoadmapId } from '@/domain/roadmap/api';
import { type RoadmapStatus, type RoadMapUpdate } from '@/domain/roadmap/types';

import { getImpact } from './enum';

export async function getEditableRoadmap(id: number, signal?: AbortSignal): Promise<RoadMapUpdate> {
  const roadmap = await getRoadMapsById(id, { signal });

  let statuses: RoadmapStatus[] = [];
  if (roadmap.type?.idRoadmapType) {
    statuses = await getRoadmapsTypeStatusesByRoadmapId(id, roadmap.type.idRoadmapType, { signal });
  }

  return {
    ...roadmap,
    owner: roadmap.owner ?? null,
    description: roadmap.description ?? '',
    detailedDescription: roadmap.detailedDescription ?? '',
    item: roadmap.item ?? '',
    qualityCertificate: roadmap.qualityCertificate ?? '',
    specification: roadmap.specification ?? '',
    milestones: roadmap.milestones ?? [],
    plants: roadmap.plants?.map((plant) => plant.idPlant) ?? [],
    okrs:
      roadmap.okrs?.map((okr) => ({
        id: okr.id,
        impact: { id: okr.impact, impact: getImpact(okr.impact) },
      })) ?? [],
    unitsImpact:
      roadmap.unitsImpact?.map((u) => ({
        unitId: u.unitId,
        isRequested: u.isRequested,
      })) ?? [],
    linkedItems: roadmap.linkedItems ?? [],
    type: roadmap.type ? { ...roadmap.type, roadmapStatus: statuses } : null,
    version: roadmap.version ?? null,
    jiraTicket: roadmap.jiraTicket ?? '',
  };
}
